import React from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import { HYPHEN_CHARACTER } from 'src/constants/Generals';
import { toDisplayFormat } from 'src/utils/Completion';
import { PAYROLL_RULES_GROUP_FORM } from 'src/constants/FormNames';
import { getRadioLabel } from '../PayrollRulesGroupsUtils';
import SemiMonthlyPreview from './SemiMonthlyPreview';

const ConfirmModal = ({ setOnCloseModal, onOpenModal, onCancel, onConfirm, formValues, options }) => {
  const { t } = useTranslation();
  const confirmData = getRadioLabel(formValues, options);
  const Item = ({ label, value, keys, component = null }) => {
    if (component) return <div style={{ margin: '10px' }}>{component}</div>;

    const content =
      _.isArray(value) && value.length > 0
        ? value.map((text, index) => (
            <li style={{ marginLeft: '15px', color: 'red' }} key={`prorate-label-${index + 1}`}>
              {text}
            </li>
          ))
        : value;
    return (
      <div style={{ margin: 10 }}>
        <h3 key={keys}>{label}</h3>
        <div style={{ marginLeft: '15px', color: 'red' }}>
          {_.isArray(value) ? <ul style={{ listStyleType: 'disc' }}>{content}</ul> : <p>{content}</p>}
          {_.isArray(value) && value.length === 0 && <p>{HYPHEN_CHARACTER}</p>}
        </div>
      </div>
    );
  };

  return (
    <CommonModal hideModal={setOnCloseModal} isOpen={onOpenModal} ariaHideApp={false} id={'ComfirmModal'}>
      <CommonModal.Header hideModal={setOnCloseModal}>{t('features.PayrollRulesGroups.components.ConfirmModal.Title')}</CommonModal.Header>
      <CommonModal.Body>
        <Item
          label={t('features.EmployeePays.components.DownloadColumnDetail.salary_rules_group_name')}
          value={confirmData.name}
          keys={'name'}
        />
        <Item
          label={t('features.Employees.components.PayrollRulenInfo.form_of_salary')}
          value={confirmData.payrollType}
          keys={'payrollType'}
        />
        <Item
          label={t('features.Employees.components.PayrollRulenInfo.payment_count')}
          value={confirmData.paymentCount}
          keys="paymentCount"
        />
        <Item
          label={t('features.Employees.components.PayrollRulenInfo.designated_working_hours_in_one_day')}
          value={confirmData.prescribedWorkingHoursPerDay}
          keys={'prescribedWorkingHoursPerDay'}
        />
        <Item
          label={t('features.Employees.components.PayrollRulenInfo.average_designated_working_days_in_one_month')}
          value={toDisplayFormat(confirmData.avgRegularWorkingDaysPerMonth)}
          keys={'avgRegularWorkingDaysPerMonth'}
        />
        <Item
          label={t('features.Employees.components.PayrollRulenInfo.average_designated_working_hours_in_one_month')}
          value={confirmData.avgRegularWorkingHoursPerMonth}
          keys={'avgRegularWorkingHoursPerMonth'}
        />
        <Item
          label={t('features.Employees.components.PayrollRulenInfo.probation_days_required')}
          value={confirmData.probationDaysRequired}
          keys={'probationDaysRequired'}
        />
        {/* @TODO: Temporarily hide twice monthly payment feature, will be developed later
          https://donuts-vn.atlassian.net/browse/JBC-92
        */}
        {/* {formValues.paymentCount === 'twice' && (
          <>
            <Item
              label={t('features.PayrollRulesGroups.components.PaymentTermSetting.payment_term')}
              value={confirmData.paymentMonthType}
              keys={'paymentMonthType'}
            />
            <Item label="Semi monthly" component={<SemiMonthlyPreview title="semi_monthly_payment_setting" showOnModal />} />
          </>
        )} */}
        {formValues.paymentCount !== 'twice' && (
          <>
            <Item
              label={t('features.Employees.components.PayrollRulenInfo.cutoff_date')}
              value={confirmData.closingDay}
              keys={'closingDay'}
            />
            <Item
              label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.payment_date_month')}
              value={confirmData.paymentMonthType}
              keys={'paymentMonthType'}
            />
            <Item
              label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.payment_date_day')}
              value={confirmData.paymentDay}
              keys={'paymentDay'}
            />
          </>
        )}

        <Item
          label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.month_of_the_applicable_sso_calculation_rate')}
          value={confirmData.applicableSsoRateMonth}
          keys={'applicableSsoRateMonth'}
        />
        <Item
          label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.Month_shown_in_payslip')}
          value={confirmData.displayMonthNameType}
          keys={'displayMonthNameType'}
        />
        <Item
          label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.is_show_attendance')}
          value={confirmData.isShowAttendance}
          keys={'isShowAttendance'}
        />
        {/* @TODO: Hide Provident Fund for Vietnam */}
        {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
        {/*
        <Item
          label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.is_show_provident_fund')}
          value={confirmData.isShowProvidentFund}
          keys={'isShowProvidentFund'}
        /> */}
        {/* @TODO: Temporarily hide twice monthly payment feature, will be developed later
          https://donuts-vn.atlassian.net/browse/JBC-92
        */}
        {/* {formValues.paymentCount === 'twice' && (
          <>
            <Item
              label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.timing_of_tax_deduction')}
              value={confirmData.timingOfTaxDeduction}
              keys="timingOfTaxDeduction}"
            />
          </>
        )} */}
      </CommonModal.Body>
      <CommonModal.Footer>
        <CommonModal.Buttons>
          <Button onClick={onCancel}>{t('features.PayrollRulesGroups.components.ConfirmModal.CancelButton')}</Button>
          <Button primary onClick={onConfirm}>
            {t('features.PayrollRulesGroups.components.ConfirmModal.ConfirmButton')}
          </Button>
        </CommonModal.Buttons>
      </CommonModal.Footer>
    </CommonModal>
  );
};

const mapStateToProps = state => ({
  formValues: getFormValues(PAYROLL_RULES_GROUP_FORM)(state),
  options: _.get(state, 'selectOptions', [])
});

export default connect(mapStateToProps)(ConfirmModal);
